// extracted by mini-css-extract-plugin
export default {"heroContainer":"Hero_heroContainer__oJDVj","heroContent":"Hero_heroContent__3EKA5","findBtn":"Hero_findBtn__GDse1","heroTxt":"Hero_heroTxt__uUBgv"};